var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"price-button"},'button',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"price-button-text"},[_vm._t("text")],2),_c('div',{staticClass:"price-button-price"},[_vm._t("price")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }